import { render } from "./MenuAgro.vue?vue&type=template&id=f6cbbf06&scoped=true"
import script from "./MenuAgro.vue?vue&type=script&lang=js"
export * from "./MenuAgro.vue?vue&type=script&lang=js"

import "./MenuAgro.vue?vue&type=style&index=0&id=f6cbbf06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6cbbf06"]])

export default __exports__